module.exports = __webpack_public_path__ + "img/GS_Profile-Tupelo Maditsi.133dac4a.png";